import React from "react";
import FooterDefault from "../../components/shared/footers/FooterDefault";
import HeaderDefaultVerify from "../../components/shared/headers/HeaderDefaultVerify";
import BreadCrumb from "../../components/elements/BreadCrumb";
import RegisterVarificationButton from "../../components/partials/account/RegisterVarificationButton";
import NavigationList from "../../components/shared/navigation/NavigationList";

const RegisterVarificationButtonPage = () => {
  const breadCrumb = [
  ];

  return (
    <div className="site-content">
          <HeaderDefaultVerify />
      <NavigationList />
      <div className="ps-page--my-account">
        <BreadCrumb breacrumb={breadCrumb} />
        <RegisterVarificationButton />
      </div>
      <FooterDefault />
    </div>
  );
};

export default RegisterVarificationButtonPage;
